// extracted by mini-css-extract-plugin
export var resizer = "_bc-0";